import { useEffect } from 'react'
import type { StatusMessage } from '../types'

interface StatusBarProps {
  message: StatusMessage | null
  onClear: () => void
}

export default function StatusBar({ message, onClear }: StatusBarProps) {
  useEffect(() => {
    if (!message) return
    const t = setTimeout(onClear, 4000)
    return () => clearTimeout(t)
  }, [message, onClear])

  if (!message) return null

  const isSuccess = message.type === 'success'
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      padding: '12px 18px',
      borderRadius: '10px',
      marginBottom: '16px',
      background: isSuccess ? 'linear-gradient(135deg, #dcfce7, #bbf7d0)' : 'linear-gradient(135deg, #fee2e2, #fecaca)',
      border: `1px solid ${isSuccess ? '#86efac' : '#fca5a5'}`,
      color: isSuccess ? '#166534' : '#991b1b',
      fontWeight: 600,
      fontSize: '14px',
      animation: 'slideIn 0.25s ease'
    }}>
      <span style={{ fontSize: '18px' }}>{isSuccess ? '✅' : '❌'}</span>
      <span style={{ flex: 1 }}>{message.text}</span>
      <button
        onClick={onClear}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          fontSize: '16px', color: 'inherit', opacity: 0.6, padding: '0 4px'
        }}
      >✕</button>
      <style>{`@keyframes slideIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  )
}
